import { ref } from 'vue';
import { appUserResourceDics, appUserResource, getAppTencentCustomMakePage, MediaType } from '@/request/customrize';
import { useUserStore } from '@/pinia';

function getUserId(): any {
  const userStore = useUserStore();
  const { userId } = userStore.getUserInfo as any;
  return userId || '';
}

function getTeamId(): any {
  // 获取本地存储的团队id
  const teamId = localStorage.getItem('teamId');
  return teamId || '';
}

// 获取用户剩余套餐资源
export function useUserPackResource() {
  const szrPackages = ref<any>([]);

  const fetchUserResource = async (params = {}) => {
    const defaultResourceArray = Object.entries(appUserResourceDics).map(([key, item]) => ({
      key,
      ...item,
      usableCount: 0,
    }));

    if (!getUserId()) {
      console.log('用户信息没有获取到');
      szrPackages.value = defaultResourceArray;
      return;
    }

    // 如果没有团队id，则获取团队权益许可
    if (!getTeamId()) {
      console.log('团队id没有获取到');
      szrPackages.value = defaultResourceArray;
      return;
    }


    try {
      const res = await appUserResource(params);
      let { code, data } = res.data;
      if (code === 200) {
        szrPackages.value = defaultResourceArray.map((resource) => {
          const matchedItem = data.find((item) => item.resourceType === resource.key);
          return matchedItem ? { ...resource, ...matchedItem } : resource;
        });
      } else {
        console.error('Failed to fetch user resources, using default values.');
        szrPackages.value = defaultResourceArray;
      }
    } catch (error) {
      console.error('Error fetching user resources:', error);
      szrPackages.value = defaultResourceArray;
    }
  };

  return {
    szrPackages,
    fetchUserResource,
  };
}

// 获取定制分页列表
const ext = (url) => url.split('.').pop().toLowerCase();
export function useAppTencentCustomMakePage() {
  const customMakeArr = ref([]);
  const fetchCustomMakePage = async (params = {}) => {
    const res = await getAppTencentCustomMakePage(params);
    let { code, data } = res.data;
    if (code === 200) {
      customMakeArr.value = data.list?.map((v) => {
        const url = v.makeType === 'VOICE_TTS' ? v?.audioUrl : v?.materialCosUrl;
        return {
          ...v,
          mediaType: url ? MediaType.get(`.${ext(url)}`) : null,
        };
      });
      return customMakeArr.value; // 添加返回值
    } else {
      customMakeArr.value = [];
      return customMakeArr.value; // 添加返回值
    }
  };

  // fetchCustomMakePage()
  return { customMakeArr, fetchCustomMakePage };
}
